import { render, staticRenderFns } from "./ProductPad.vue?vue&type=template&id=2543c748&scoped=true"
import script from "./ProductPad.vue?vue&type=script&lang=js"
export * from "./ProductPad.vue?vue&type=script&lang=js"
import style0 from "./ProductPad.vue?vue&type=style&index=0&id=2543c748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543c748",
  null
  
)

export default component.exports